import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { userIsNotAuthenticatedRedir, userIsAdminRedir } from "./config/auth";
import { loginResponse } from "./store/actions/authActions";
import { fetchCheckLogin } from "./store/actions/beranda/berandaActions";
import { toastr } from "react-redux-toastr";
import Loading from "./components/loading/Loading";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
const DefaultLayout = React.lazy(() => import("./containers/layout/Layout"));
// const Login = React.lazy(() => import('./containers/auth/login/Login'));
const Beranda = React.lazy(() => import("./containers/beranda/BerandaBAI"));

// const Home = userIsAdminRedir(DefaultLayout);
// const Sign = userIsNotAuthenticatedRedir(Beranda);

// const loading = () => <Loading/>

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Home: null,
      Sign: null,
      isLoading: true, // Tambahkan state loading
    };
  }
  componentDidMount() {
    this.fetchCheckLogin();
  }
  fetchCheckLogin = () => {
    if (localStorage.getItem("token") === null) {
      const path = window.location.pathname;
      const tokenmicrosoft = path.split("/beranda/")[1];
      const payload = { token: tokenmicrosoft };
      this.props
        .fetchCheckLogin(payload)
        .then((response) => {
          this.setState({ loading: false });
          const { authorization } = response.headers;
          const access = response.data.status;
          var keyAccess = "";
          if (access === "success") {
            keyAccess = "OK";
          } else {
            keyAccess = "NO";
          }
          const dataDispatch = {
            type: true,
            authorization,
            keyAccess,
            data: response.data,
          };
          this.props.loginResponse(dataDispatch);
          localStorage.setItem("token-microsoft", tokenmicrosoft);
          this.setState({
            Home: userIsAdminRedir(DefaultLayout),
            Sign: userIsNotAuthenticatedRedir(Beranda),
            isLoading: false,
          });
        })
        .catch((resp) => {
          const dataDispatch = { type: false };
          this.props.loginResponse(dataDispatch);
          this.setState({
            Home: userIsAdminRedir(DefaultLayout),
            Sign: userIsNotAuthenticatedRedir(Beranda),
            isLoading: false,
          });
        });
    } else {
      this.setState({
        Home: userIsAdminRedir(DefaultLayout),
        Sign: userIsNotAuthenticatedRedir(Beranda),
        isLoading: false,
      });
    }
  };
  render() {
    const { Home, Sign, isLoading } = this.state;

    if (isLoading) {
      return <Loading />;
    }
    return (
      <React.Fragment>
        <BrowserRouter>
          <React.Suspense fallback={<Loading />}>
            <Route
              exact
              path="/beranda"
              name="Login Page"
              label="Login Page"
              render={(props) => <Sign {...props} />}
            />
            <Route
              path="/"
              name="Home"
              render={(props) => <Home {...props} />}
            ></Route>
          </React.Suspense>
        </BrowserRouter>
      </React.Fragment>
    );
  }
}

const stateToProps = (state) => {
  return {};
};

const dispatchToProps = (dispatch) => {
  return {
    fetchCheckLogin: (params) => dispatch(fetchCheckLogin(params)),
    loginResponse: (data) => dispatch(loginResponse(data)),
  };
};

export default connect(
  stateToProps,
  dispatchToProps
)(withTranslation("common")(App));
